import { mapArray } from "@/core/mapping";

export function mapSeries({ items }) {
    return mapArray(items, {
        id: "id",
        name: "name",
        image: "image",
        mobileImage: "mobileImage",
        count: "count",
    });
}
